import { SubscriptionLine } from '../App';

type ProductInfoType = {
  productTitle: string;
  image?: string;
  variantTitle: string;
  originalPrice: number;
  price: number;
  quantity: number;
  variantId: string;
  planId?: string;
  lineId?: string;
};

export type { ProductInfoType };

export const createProductInfo = (line: SubscriptionLine): ProductInfoType => {
  return {
    productTitle: line.title,
    image: line.variantImage,
    variantTitle: line.variantTitle,
    originalPrice: line.lineDiscountedPriceAmount,
    price: line.currentPriceAmount,
    quantity: line.quantity,
    variantId: line.variantId,
    lineId: line.lineId,
  };
};
